import React from 'react'

interface FAQItemProps {
  question: string
  answer: string
  isOpen: boolean
  onToggle: () => void
}

const FAQItem: React.FC<FAQItemProps> = ({
  question,
  answer,
  isOpen,
  onToggle,
}) => {
  return (
    <div className='border-b border-gray-200 last:border-b-0'>
      <button
        className='w-full py-6 px-6 flex items-center justify-between text-left  transition-colors'
        onClick={onToggle}
      >
        <span className='text-lg font-medium text-gray-900 pr-4'>
          {question}
        </span>
        <div className='flex-shrink-0'>
          {isOpen ? (
            <div className='w-8 h-8 bg-red-500 rounded-full flex items-center justify-center'>
              <svg
                className='w-4 h-4 text-white'
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M20 12H4'
                />
              </svg>
            </div>
          ) : (
            <div
              className='w-8 h-8 rounded-full flex items-center justify-center'
              style={{ backgroundColor: 'rgba(28, 28, 41, 0.08)' }}
            >
              <svg
                className='w-4 h-4 text-black'
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M12 6v6m0 0v6m0-6h6m-6 0H6'
                />
              </svg>
            </div>
          )}
        </div>
      </button>
      {isOpen && (
        <div className='px-6 pb-6'>
          <p className='text-[#747986] leading-relaxed text-start text-[16px]'>
            {answer}
          </p>
        </div>
      )}
    </div>
  )
}

export default FAQItem
